import { render, staticRenderFns } from "./EditPopupDialog.vue?vue&type=template&id=bd31bc04&scoped=true&"
import script from "./EditPopupDialog.vue?vue&type=script&lang=js&"
export * from "./EditPopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditPopupDialog.vue?vue&type=style&index=0&id=bd31bc04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd31bc04",
  null
  
)

export default component.exports